import React from 'react';
import PropTypes from 'prop-types';

import Copy from '@components/atoms/copy/copy';

const EvaluationWishes = ({ items, locale }) => (
  <div className="evaluation__top-wishes">
    {items.map((item, index) => (
      <div key={index} className="evaluation__wish">
        <div className="evaluation__wish-text">
          <Copy noMargin>{item.title[locale === 'de' ? 0 : 1]}</Copy>
        </div>
        <div className="evaluation__wish-number">
          <Copy noMargin>{index + 1}</Copy>
        </div>
      </div>
    ))}
  </div>
);

EvaluationWishes.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape()),
  locale: PropTypes.string
};

export default EvaluationWishes;
